<template>
  <b-container>
    <b-row>
      <b-col>
        <div>
          <!-- TITLE -->
          <div class="mb-3 text-center" style="font-size: 14px;font-weight: bold">
            {{ dashboardTitle }}
          </div>
          <form class="mt-3 form-inline d-flex justify-content-center">
            <div class="form-group">
              <!-- SEASON SELECT -->
              <label class="mr-3">{{ $tr('general-dashboard-season', 'Season') }}</label>
              <b-form-select
                  class="mr-3"
                  v-model="selectedSeasonId"
                  @change="onChangeSeason"
                  :options="seasonOptions"
                  size="sm"
              ></b-form-select>
            </div>
          </form>

          <!-- MERCHANT SELECT -->
          <form class="mt-3 form-inline d-flex justify-content-center">
            <div class="form-group">
              <label class="mr-3">{{ $tr('general-dashboard-merchant', 'Merchant') }}</label>
              <b-form-select
                  class="mr-3"
                  v-model="selectedMerchantId"
                  @change="onChangeMerchant"
                  :options="merchantOptions"
                  size="sm"
              ></b-form-select>
            </div>
          </form>

          <!-- LOADING -->
          <b-row
              v-if="loading"
              no-gutters
              style="max-height: 200px !important; justify-content: center">
            <loading :stretch="false"></loading>
          </b-row>

          <!-- CHART -->
          <b-row
              v-if="this.chartData.data[0] && !loading"
              class="mt-2">
            <div style="position: relative; height:380px" class="w-100 d-flex justify-content-center">
              <canvas
                  ref="chartCanvas"
                  :id="'chartCanvas' + id"
                  style="max-height: 100%"></canvas>
            </div>
          </b-row>

          <!-- CHOOSE A SEASON -->
          <div
              v-if="!selectedSeasonId && !loading"
              class="text-center mt-3"
              style="font-weight: bold; color: rgb(255, 99, 132)"
              v-text="$tr('general-dashboard-choose-season', 'Choose a Season')"
          >
          </div>

          <!-- NO DATA INFO -->
          <div
              v-if="!this.chartData.data[0] && selectedSeasonId && !loading "
              class="text-center mt-3"
              style="font-weight: bold; color: rgb(255, 99, 132)"
              v-text="$tr('general-dashboard-no-such-data', 'No Such Data Found')"
          >
          </div>
        </div>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import Loading from "@/components/layout/Loading.vue";
import DashletsRpc from "@/DashletsRpc";
import DashletConfig from "@/server/com/silkplm/engine/dashboards/DashletConfig";
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import _ from "lodash";
import DashletsHome from "@/components/dashboard/DashletsHome.vue";

export default {
  name: "GeneralDashboard",
  components: {
    Loading,
    DashletsHome
  },

  async mounted() {
    // Load saved selectedSeasonId from localStorage
    const savedSeasonId = localStorage.getItem(`selectedSeasonId-${this.uuid}`);
    if (savedSeasonId) {
      this.selectedSeasonId = savedSeasonId;
    } else {
      this.selectedSeasonId = this.config.selected;
    }

    // Load saved selectedMerchantId from localStorage
    const savedMerchantId = localStorage.getItem(`selectedMerchantId-${this.uuid}`);
    if (savedMerchantId) {
      this.selectedMerchantId = savedMerchantId;
    } else {
      this.selectedMerchantId = null;
    }

    this.seasons = await DashletsRpc.DashboardsGeneral.getSeasonList();
    this.seasonOptions = this.seasons.map(season => {
      return {value: season.id, text: season.season};
    });

    this.merchants = await DashletsRpc.DashboardsGeneral.getApplicationUserList();
    const data = this.merchants.map(merchant => {
      return {
        value: merchant.id,
        text: merchant.email
      };
    });
    this.merchantOptions = [{value: null, text: 'All'}, ...data];
    this.loading = false;

    if (!this.seasons.find(season => season.id === this.selectedSeasonId)) {
      this.selectedSeasonId = null;
      return;
    }

    this.loading = false;
    this.$emit('load-data', this.selectedSeasonId, this.selectedMerchantId);
  },

  methods: {
    async getDataToChart(data) {
      this.chartData.data = [...data];
      this.productsGood = this.chartData.data[0];
      this.productsBad = this.chartData.data[1];
      this.chartData.backgroundColor = [this.colorGood, this.colorBad];
      this.$nextTick(() => {
        this.updateChart();
      });
    },

    async onChangeSeason() {
      this.config.selected = this.selectedSeasonId;
      localStorage.setItem(`selectedSeasonId-${this.uuid}`, this.selectedSeasonId);
      this.$emit('load-data', this.selectedSeasonId, this.selectedMerchantId);
      this.$emit('config-change');
    },

    async onChangeMerchant() {
      localStorage.setItem(`selectedMerchantId-${this.uuid}`, this.selectedMerchantId);
      this.$emit('load-data', this.selectedSeasonId, this.selectedMerchantId);
    },

    // CHART
    getOrCreateTooltip(chart) {
      let tooltipEl = chart.canvas.parentNode.querySelector('div');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';
        chart.canvas.parentNode.appendChild(tooltipEl);
      }
      return tooltipEl;
    },

    generateToolTip(context) {
      const {chart, tooltip} = context;
      const tooltipEl = this.getOrCreateTooltip(chart);
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }
      // Set Text
      if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map(b => b.lines);
      }
      // tooltipEl.innerHTML = 'Click to see the products';

      const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.left = positionX + tooltip.caretX + 'px';
      tooltipEl.style.top = positionY + tooltip.caretY + 'px';
      tooltipEl.style.font = tooltip.options.bodyFont.string;
      tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
    },

    setupChart() {
      const dataDoughnut = {
        labels: [
          this.labelWith + ' (' + this.productsGood + ')',
          this.labelWithout + ' (' + this.productsBad + ')'
        ],

        datasets: [{
          data: this.chartData.data,
          backgroundColor: this.chartData.backgroundColor,
          hoverOffset: 4
        }]
      };

      const canvas = document.getElementById('chartCanvas' + this.id).getContext('2d');
      this.chart = new Chart(canvas, {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        options: {
          animation: true,
          responsive: true,
          plugins: {
            datalabels: {
              formatter: function (value, context) {
                const sum = _.sum(context.chart.data.datasets[0].data);
                return (value * 100 / sum).toFixed(1) + "%";
              },
              align: 'center',
              color: 'white',
              font: {
                size: 18
              }
            },
            legend: {
              display: true
            },
            tooltip: {
              enabled: false,
              position: 'nearest',
              external: (context) => this.generateToolTip(context)
            }
          }
        },
        data: dataDoughnut
      });
    },

    updateChart() {
      if (this.chart) {
        this.chart.destroy(); // Destroy existing chart
      }
      this.setupChart(); // Setup new chart
    }
  },

  props: {
    uuid: {type: String, required: true},
    dashletConfig: {type: DashletConfig},
    config: {type: Object},
    dashboardTitle: {type: String},
    labelWith: {type: String},
    labelWithout: {type: String},
    colorGood: {type: String},
    colorBad: {type: String},
    id: {type: Number, required: true}
  },

  data() {
    return {
      loading: true,
      productsGood: 0,
      productsBad: 0,
      chartData: {
        data: [],
        backgroundColor: [],
      },
      selectedSeasonId: null,
      seasonOptions: [],
      seasons: [],
      merchants: [],
      merchantOptions: [{
        value: null, text: 'All'
      }],
      selectedMerchantId: null,
      localStorageKey: `selectedSeasonId-${this.uuid}`,
    };
  }
};
</script>

<style scoped>
</style>
